module.exports = __webpack_public_path__ + "static/media/05.d7fe9dfa.jpg";